import { FloEvent } from '@flocasts/flosports30-types/dist/entity'

export const getEventPartner = (event: Pick<FloEvent, 'node'>) =>
  event.node && event.node.supporters
    ? event.node.supporters.filter(supporter => supporter.supporter_type === 'partner')[0]
    : undefined
